/* Larnos — interacțiuni minime */
(function () {
  var drawer = document.getElementById('menu');
  document.querySelectorAll('[data-menu-open]').forEach(function (b) {
    b.addEventListener('click', function () { drawer.showModal(); document.body.classList.add('is-locked'); });
  });
  document.querySelectorAll('[data-menu-close]').forEach(function (b) {
    b.addEventListener('click', function () { drawer.close(); });
  });
  if (drawer) {
    drawer.addEventListener('click', function (e) { if (e.target === drawer) drawer.close(); });
    drawer.addEventListener('close', function () { document.body.classList.remove('is-locked'); });
  }

  var stage = document.querySelector('[data-stage]');
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (stage) { stage.removeAttribute('srcset'); stage.src = t.dataset.thumb; }
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
    });
  });

  document.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var i = b.parentNode.querySelector('input');
      i.value = Math.max(1, (parseInt(i.value, 10) || 1) + parseInt(b.dataset.qty, 10));
    });
  });

  var form = document.querySelector('[data-buyform]');
  var bar = document.querySelector('[data-stickybuy]');
  var barBtn = document.querySelector('[data-stickybuy-cta]');
  if (barBtn && form) barBtn.addEventListener('click', function () { form.requestSubmit(); });
  if (form && bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      bar.hidden = e[0].isIntersecting || e[0].boundingClientRect.top > 0;
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(form);
  }
})();
